import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _74432aa9 = () => interopDefault(import('../pages/404/index.vue' /* webpackChunkName: "pages/404/index" */))
const _7ba7a13e = () => interopDefault(import('../pages/about/index.vue' /* webpackChunkName: "pages/about/index" */))
const _57d70432 = () => interopDefault(import('../pages/aftersalespolicy/index.vue' /* webpackChunkName: "pages/aftersalespolicy/index" */))
const _22aaf262 = () => interopDefault(import('../pages/agriculture/index.vue' /* webpackChunkName: "pages/agriculture/index" */))
const _45958466 = () => interopDefault(import('../pages/basicinfo/index.vue' /* webpackChunkName: "pages/basicinfo/index" */))
const _681bdea7 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _5690a690 = () => interopDefault(import('../pages/blogdetail/index.vue' /* webpackChunkName: "pages/blogdetail/index" */))
const _5742165a = () => interopDefault(import('../pages/brand-upgraded/index.vue' /* webpackChunkName: "pages/brand-upgraded/index" */))
const _4d194716 = () => interopDefault(import('../pages/construction/index.vue' /* webpackChunkName: "pages/construction/index" */))
const _79d894fb = () => interopDefault(import('../pages/consumer/index.vue' /* webpackChunkName: "pages/consumer/index" */))
const _13022ede = () => interopDefault(import('../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _0584589b = () => interopDefault(import('../pages/cookiepolicy/index.vue' /* webpackChunkName: "pages/cookiepolicy/index" */))
const _65c05dc0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _79bf9443 = () => interopDefault(import('../pages/index/index.vue' /* webpackChunkName: "pages/index/index" */))
const _1a881c44 = () => interopDefault(import('../pages/dealer/index.vue' /* webpackChunkName: "pages/dealer/index" */))
const _9d8e7d3c = () => interopDefault(import('../pages/electric/index.vue' /* webpackChunkName: "pages/electric/index" */))
const _385ae219 = () => interopDefault(import('../pages/emergencypower/index.vue' /* webpackChunkName: "pages/emergencypower/index" */))
const _173f67cb = () => interopDefault(import('../pages/facebook/index.vue' /* webpackChunkName: "pages/facebook/index" */))
const _7948a38c = () => interopDefault(import('../pages/fjd-farmbook-farm-management-software/index.vue' /* webpackChunkName: "pages/fjd-farmbook-farm-management-software/index" */))
const _0c7fc2dd = () => interopDefault(import('../pages/FJD-witness/index.vue' /* webpackChunkName: "pages/FJD-witness/index" */))
const _35bb4250 = () => interopDefault(import('../pages/geospatial/index.vue' /* webpackChunkName: "pages/geospatial/index" */))
const _3e83de3a = () => interopDefault(import('../pages/industry/index.vue' /* webpackChunkName: "pages/industry/index" */))
const _29285cf9 = () => interopDefault(import('../pages/kol/index.vue' /* webpackChunkName: "pages/kol/index" */))
const _d1d413aa = () => interopDefault(import('../pages/privacypolicy/index.vue' /* webpackChunkName: "pages/privacypolicy/index" */))
const _dbdfcac0 = () => interopDefault(import('../pages/product/index.vue' /* webpackChunkName: "pages/product/index" */))
const _5d054c6b = () => interopDefault(import('../pages/productservice/index.vue' /* webpackChunkName: "pages/productservice/index" */))
const _26e3323c = () => interopDefault(import('../pages/result/index.vue' /* webpackChunkName: "pages/result/index" */))
const _fe0709e4 = () => interopDefault(import('../pages/robots/index.vue' /* webpackChunkName: "pages/robots/index" */))
const _33d5650a = () => interopDefault(import('../pages/searchresult/index.vue' /* webpackChunkName: "pages/searchresult/index" */))
const _34531856 = () => interopDefault(import('../pages/shippingrates/index.vue' /* webpackChunkName: "pages/shippingrates/index" */))
const _154a9500 = () => interopDefault(import('../pages/support/index.vue' /* webpackChunkName: "pages/support/index" */))
const _369d087f = () => interopDefault(import('../pages/template/index.vue' /* webpackChunkName: "pages/template/index" */))
const _16ef5f6a = () => interopDefault(import('../pages/videoList/index.vue' /* webpackChunkName: "pages/videoList/index" */))
const _6ba30b70 = () => interopDefault(import('../pages/webinarcenter/index.vue' /* webpackChunkName: "pages/webinarcenter/index" */))
const _4f7bd5ad = () => interopDefault(import('../pages/ads/autosteering-kit/index.vue' /* webpackChunkName: "pages/ads/autosteering-kit/index" */))
const _82636bba = () => interopDefault(import('../pages/ads/excavator-guidance-b/index.vue' /* webpackChunkName: "pages/ads/excavator-guidance-b/index" */))
const _41cc51f9 = () => interopDefault(import('../pages/product/aerial-mapper/index.vue' /* webpackChunkName: "pages/product/aerial-mapper/index" */))
const _d9cc1478 = () => interopDefault(import('../pages/product/aerial-mapper-specs/index.vue' /* webpackChunkName: "pages/product/aerial-mapper-specs/index" */))
const _7a84c15c = () => interopDefault(import('../pages/product/al01-3d-land-leveling-system/index.vue' /* webpackChunkName: "pages/product/al01-3d-land-leveling-system/index" */))
const _aae7e232 = () => interopDefault(import('../pages/product/al01-3d-land-leveling-system-specs/index.vue' /* webpackChunkName: "pages/product/al01-3d-land-leveling-system-specs/index" */))
const _060c28f2 = () => interopDefault(import('../pages/product/autosteeringkit/index.vue' /* webpackChunkName: "pages/product/autosteeringkit/index" */))
const _990f966e = () => interopDefault(import('../pages/product/autosteeringspecs/index.vue' /* webpackChunkName: "pages/product/autosteeringspecs/index" */))
const _4cf2b858 = () => interopDefault(import('../pages/product/basestation/index.vue' /* webpackChunkName: "pages/product/basestation/index" */))
const _3a512f6c = () => interopDefault(import('../pages/product/dieselgenerator/index.vue' /* webpackChunkName: "pages/product/dieselgenerator/index" */))
const _147dfa76 = () => interopDefault(import('../pages/product/dieselgeneratorspec/index.vue' /* webpackChunkName: "pages/product/dieselgeneratorspec/index" */))
const _78c1851f = () => interopDefault(import('../pages/product/dieselgensent/index.vue' /* webpackChunkName: "pages/product/dieselgensent/index" */))
const _1cf6ad1a = () => interopDefault(import('../pages/product/dieselgensentspec/index.vue' /* webpackChunkName: "pages/product/dieselgensentspec/index" */))
const _04fa91f6 = () => interopDefault(import('../pages/product/disinfectionRobot/index.vue' /* webpackChunkName: "pages/product/disinfectionRobot/index" */))
const _305aa8f8 = () => interopDefault(import('../pages/product/excavatorguidance/index.vue' /* webpackChunkName: "pages/product/excavatorguidance/index" */))
const _4fa008bc = () => interopDefault(import('../pages/product/excavatorSpecs/index.vue' /* webpackChunkName: "pages/product/excavatorSpecs/index" */))
const _5d2c9e4e = () => interopDefault(import('../pages/product/fjd-connect/index.vue' /* webpackChunkName: "pages/product/fjd-connect/index" */))
const _7ebbe62f = () => interopDefault(import('../pages/product/fjd-easy-dig-2d-excav-specs/index.vue' /* webpackChunkName: "pages/product/fjd-easy-dig-2d-excav-specs/index" */))
const _50e9676b = () => interopDefault(import('../pages/product/fjd-easy-dig-g21-2d-excav/index.vue' /* webpackChunkName: "pages/product/fjd-easy-dig-g21-2d-excav/index" */))
const _08ab8f47 = () => interopDefault(import('../pages/product/lawnmower/index.vue' /* webpackChunkName: "pages/product/lawnmower/index" */))
const _36ff6342 = () => interopDefault(import('../pages/product/lawnmowerspec/index.vue' /* webpackChunkName: "pages/product/lawnmowerspec/index" */))
const _4871073e = () => interopDefault(import('../pages/product/orchardPlantProtection/index.vue' /* webpackChunkName: "pages/product/orchardPlantProtection/index" */))
const _033aded0 = () => interopDefault(import('../pages/product/orchardPlantProtectionSpecs/index.vue' /* webpackChunkName: "pages/product/orchardPlantProtectionSpecs/index" */))
const _7fae347f = () => interopDefault(import('../pages/product/piledriver/index.vue' /* webpackChunkName: "pages/product/piledriver/index" */))
const _c549c45e = () => interopDefault(import('../pages/product/powersec/index.vue' /* webpackChunkName: "pages/product/powersec/index" */))
const _965ec668 = () => interopDefault(import('../pages/product/powersecspec/index.vue' /* webpackChunkName: "pages/product/powersecspec/index" */))
const _31894cbe = () => interopDefault(import('../pages/product/refractometer/index.vue' /* webpackChunkName: "pages/product/refractometer/index" */))
const _17438d39 = () => interopDefault(import('../pages/product/refractometerspec/index.vue' /* webpackChunkName: "pages/product/refractometerspec/index" */))
const _0989e324 = () => interopDefault(import('../pages/product/ricetransplanter/index.vue' /* webpackChunkName: "pages/product/ricetransplanter/index" */))
const _49dcf6e9 = () => interopDefault(import('../pages/product/ricetransplanterspec/index.vue' /* webpackChunkName: "pages/product/ricetransplanterspec/index" */))
const _90d3aa70 = () => interopDefault(import('../pages/product/tractor/index.vue' /* webpackChunkName: "pages/product/tractor/index" */))
const _23bda9a6 = () => interopDefault(import('../pages/product/tractorspecs/index.vue' /* webpackChunkName: "pages/product/tractorspecs/index" */))
const _2cd812ca = () => interopDefault(import('../pages/product/trion-s1-3d-lidar-scanner/index.vue' /* webpackChunkName: "pages/product/trion-s1-3d-lidar-scanner/index" */))
const _b367d456 = () => interopDefault(import('../pages/product/trion-s1-3d-lidar-scanner-specs/index.vue' /* webpackChunkName: "pages/product/trion-s1-3d-lidar-scanner-specs/index" */))
const _01e504a8 = () => interopDefault(import('../pages/product/trion-v1-series-rtk-rover/index.vue' /* webpackChunkName: "pages/product/trion-v1-series-rtk-rover/index" */))
const _448a4f37 = () => interopDefault(import('../pages/product/trion-v1-series-rtk-rover-specs/index.vue' /* webpackChunkName: "pages/product/trion-v1-series-rtk-rover-specs/index" */))
const _5666e1c2 = () => interopDefault(import('../pages/product/wificamera/index.vue' /* webpackChunkName: "pages/product/wificamera/index" */))
const _8a55d230 = () => interopDefault(import('../pages/activity/webinardetail/_id.vue' /* webpackChunkName: "pages/activity/webinardetail/_id" */))
const _c2e14262 = () => interopDefault(import('../pages/blog/_id.vue' /* webpackChunkName: "pages/blog/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _74432aa9,
    name: "404___en"
  }, {
    path: "/about",
    component: _7ba7a13e,
    name: "about___en"
  }, {
    path: "/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___en"
  }, {
    path: "/agriculture",
    component: _22aaf262,
    name: "agriculture___en"
  }, {
    path: "/basicinfo",
    component: _45958466,
    name: "basicinfo___en"
  }, {
    path: "/blog",
    component: _681bdea7,
    name: "blog___en"
  }, {
    path: "/blogdetail",
    component: _5690a690,
    name: "blogdetail___en"
  }, {
    path: "/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___en"
  }, {
    path: "/construction",
    component: _4d194716,
    name: "construction___en"
  }, {
    path: "/consumer",
    component: _79d894fb,
    name: "consumer___en"
  }, {
    path: "/contact",
    component: _13022ede,
    name: "contact___en"
  }, {
    path: "/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___en"
  }, {
    path: "/de",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___de"
    }]
  }, {
    path: "/dealer",
    component: _1a881c44,
    name: "dealer___en"
  }, {
    path: "/electric",
    component: _9d8e7d3c,
    name: "electric___en"
  }, {
    path: "/emergencypower",
    component: _385ae219,
    name: "emergencypower___en"
  }, {
    path: "/es",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___es"
    }]
  }, {
    path: "/facebook",
    component: _173f67cb,
    name: "facebook___en"
  }, {
    path: "/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___en"
  }, {
    path: "/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___en"
  }, {
    path: "/fr",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___fr"
    }]
  }, {
    path: "/geospatial",
    component: _35bb4250,
    name: "geospatial___en"
  }, {
    path: "/industry",
    component: _3e83de3a,
    name: "industry___en"
  }, {
    path: "/jp",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___jp"
    }]
  }, {
    path: "/kol",
    component: _29285cf9,
    name: "kol___en"
  }, {
    path: "/pl",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___pl"
    }]
  }, {
    path: "/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___en"
  }, {
    path: "/product",
    component: _dbdfcac0,
    name: "product___en"
  }, {
    path: "/productservice",
    component: _5d054c6b,
    name: "productservice___en"
  }, {
    path: "/pt",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___pt"
    }]
  }, {
    path: "/result",
    component: _26e3323c,
    name: "result___en"
  }, {
    path: "/robots",
    component: _fe0709e4,
    name: "robots___en"
  }, {
    path: "/ru",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___ru"
    }]
  }, {
    path: "/searchresult",
    component: _33d5650a,
    name: "searchresult___en"
  }, {
    path: "/shippingrates",
    component: _34531856,
    name: "shippingrates___en"
  }, {
    path: "/support",
    component: _154a9500,
    name: "support___en"
  }, {
    path: "/sv",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___sv"
    }]
  }, {
    path: "/template",
    component: _369d087f,
    name: "template___en"
  }, {
    path: "/tr",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___tr"
    }]
  }, {
    path: "/videoList",
    component: _16ef5f6a,
    name: "videoList___en"
  }, {
    path: "/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___en"
  }, {
    path: "/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___en"
  }, {
    path: "/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___en"
  }, {
    path: "/de/404",
    component: _74432aa9,
    name: "404___de"
  }, {
    path: "/de/about",
    component: _7ba7a13e,
    name: "about___de"
  }, {
    path: "/de/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___de"
  }, {
    path: "/de/agriculture",
    component: _22aaf262,
    name: "agriculture___de"
  }, {
    path: "/de/basicinfo",
    component: _45958466,
    name: "basicinfo___de"
  }, {
    path: "/de/blog",
    component: _681bdea7,
    name: "blog___de"
  }, {
    path: "/de/blogdetail",
    component: _5690a690,
    name: "blogdetail___de"
  }, {
    path: "/de/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___de"
  }, {
    path: "/de/construction",
    component: _4d194716,
    name: "construction___de"
  }, {
    path: "/de/consumer",
    component: _79d894fb,
    name: "consumer___de"
  }, {
    path: "/de/contact",
    component: _13022ede,
    name: "contact___de"
  }, {
    path: "/de/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___de"
  }, {
    path: "/de/dealer",
    component: _1a881c44,
    name: "dealer___de"
  }, {
    path: "/de/electric",
    component: _9d8e7d3c,
    name: "electric___de"
  }, {
    path: "/de/emergencypower",
    component: _385ae219,
    name: "emergencypower___de"
  }, {
    path: "/de/facebook",
    component: _173f67cb,
    name: "facebook___de"
  }, {
    path: "/de/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___de"
  }, {
    path: "/de/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___de"
  }, {
    path: "/de/geospatial",
    component: _35bb4250,
    name: "geospatial___de"
  }, {
    path: "/de/industry",
    component: _3e83de3a,
    name: "industry___de"
  }, {
    path: "/de/kol",
    component: _29285cf9,
    name: "kol___de"
  }, {
    path: "/de/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___de"
  }, {
    path: "/de/product",
    component: _dbdfcac0,
    name: "product___de"
  }, {
    path: "/de/productservice",
    component: _5d054c6b,
    name: "productservice___de"
  }, {
    path: "/de/result",
    component: _26e3323c,
    name: "result___de"
  }, {
    path: "/de/robots",
    component: _fe0709e4,
    name: "robots___de"
  }, {
    path: "/de/searchresult",
    component: _33d5650a,
    name: "searchresult___de"
  }, {
    path: "/de/shippingrates",
    component: _34531856,
    name: "shippingrates___de"
  }, {
    path: "/de/support",
    component: _154a9500,
    name: "support___de"
  }, {
    path: "/de/template",
    component: _369d087f,
    name: "template___de"
  }, {
    path: "/de/videoList",
    component: _16ef5f6a,
    name: "videoList___de"
  }, {
    path: "/de/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___de"
  }, {
    path: "/es/404",
    component: _74432aa9,
    name: "404___es"
  }, {
    path: "/es/about",
    component: _7ba7a13e,
    name: "about___es"
  }, {
    path: "/es/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___es"
  }, {
    path: "/es/agriculture",
    component: _22aaf262,
    name: "agriculture___es"
  }, {
    path: "/es/basicinfo",
    component: _45958466,
    name: "basicinfo___es"
  }, {
    path: "/es/blog",
    component: _681bdea7,
    name: "blog___es"
  }, {
    path: "/es/blogdetail",
    component: _5690a690,
    name: "blogdetail___es"
  }, {
    path: "/es/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___es"
  }, {
    path: "/es/construction",
    component: _4d194716,
    name: "construction___es"
  }, {
    path: "/es/consumer",
    component: _79d894fb,
    name: "consumer___es"
  }, {
    path: "/es/contact",
    component: _13022ede,
    name: "contact___es"
  }, {
    path: "/es/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___es"
  }, {
    path: "/es/dealer",
    component: _1a881c44,
    name: "dealer___es"
  }, {
    path: "/es/electric",
    component: _9d8e7d3c,
    name: "electric___es"
  }, {
    path: "/es/emergencypower",
    component: _385ae219,
    name: "emergencypower___es"
  }, {
    path: "/es/facebook",
    component: _173f67cb,
    name: "facebook___es"
  }, {
    path: "/es/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___es"
  }, {
    path: "/es/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___es"
  }, {
    path: "/es/geospatial",
    component: _35bb4250,
    name: "geospatial___es"
  }, {
    path: "/es/industry",
    component: _3e83de3a,
    name: "industry___es"
  }, {
    path: "/es/kol",
    component: _29285cf9,
    name: "kol___es"
  }, {
    path: "/es/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___es"
  }, {
    path: "/es/product",
    component: _dbdfcac0,
    name: "product___es"
  }, {
    path: "/es/productservice",
    component: _5d054c6b,
    name: "productservice___es"
  }, {
    path: "/es/result",
    component: _26e3323c,
    name: "result___es"
  }, {
    path: "/es/robots",
    component: _fe0709e4,
    name: "robots___es"
  }, {
    path: "/es/searchresult",
    component: _33d5650a,
    name: "searchresult___es"
  }, {
    path: "/es/shippingrates",
    component: _34531856,
    name: "shippingrates___es"
  }, {
    path: "/es/support",
    component: _154a9500,
    name: "support___es"
  }, {
    path: "/es/template",
    component: _369d087f,
    name: "template___es"
  }, {
    path: "/es/videoList",
    component: _16ef5f6a,
    name: "videoList___es"
  }, {
    path: "/es/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___es"
  }, {
    path: "/fr/404",
    component: _74432aa9,
    name: "404___fr"
  }, {
    path: "/fr/about",
    component: _7ba7a13e,
    name: "about___fr"
  }, {
    path: "/fr/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___fr"
  }, {
    path: "/fr/agriculture",
    component: _22aaf262,
    name: "agriculture___fr"
  }, {
    path: "/fr/basicinfo",
    component: _45958466,
    name: "basicinfo___fr"
  }, {
    path: "/fr/blog",
    component: _681bdea7,
    name: "blog___fr"
  }, {
    path: "/fr/blogdetail",
    component: _5690a690,
    name: "blogdetail___fr"
  }, {
    path: "/fr/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___fr"
  }, {
    path: "/fr/construction",
    component: _4d194716,
    name: "construction___fr"
  }, {
    path: "/fr/consumer",
    component: _79d894fb,
    name: "consumer___fr"
  }, {
    path: "/fr/contact",
    component: _13022ede,
    name: "contact___fr"
  }, {
    path: "/fr/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___fr"
  }, {
    path: "/fr/dealer",
    component: _1a881c44,
    name: "dealer___fr"
  }, {
    path: "/fr/electric",
    component: _9d8e7d3c,
    name: "electric___fr"
  }, {
    path: "/fr/emergencypower",
    component: _385ae219,
    name: "emergencypower___fr"
  }, {
    path: "/fr/facebook",
    component: _173f67cb,
    name: "facebook___fr"
  }, {
    path: "/fr/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___fr"
  }, {
    path: "/fr/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___fr"
  }, {
    path: "/fr/geospatial",
    component: _35bb4250,
    name: "geospatial___fr"
  }, {
    path: "/fr/industry",
    component: _3e83de3a,
    name: "industry___fr"
  }, {
    path: "/fr/kol",
    component: _29285cf9,
    name: "kol___fr"
  }, {
    path: "/fr/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___fr"
  }, {
    path: "/fr/product",
    component: _dbdfcac0,
    name: "product___fr"
  }, {
    path: "/fr/productservice",
    component: _5d054c6b,
    name: "productservice___fr"
  }, {
    path: "/fr/result",
    component: _26e3323c,
    name: "result___fr"
  }, {
    path: "/fr/robots",
    component: _fe0709e4,
    name: "robots___fr"
  }, {
    path: "/fr/searchresult",
    component: _33d5650a,
    name: "searchresult___fr"
  }, {
    path: "/fr/shippingrates",
    component: _34531856,
    name: "shippingrates___fr"
  }, {
    path: "/fr/support",
    component: _154a9500,
    name: "support___fr"
  }, {
    path: "/fr/template",
    component: _369d087f,
    name: "template___fr"
  }, {
    path: "/fr/videoList",
    component: _16ef5f6a,
    name: "videoList___fr"
  }, {
    path: "/fr/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___fr"
  }, {
    path: "/jp/404",
    component: _74432aa9,
    name: "404___jp"
  }, {
    path: "/jp/about",
    component: _7ba7a13e,
    name: "about___jp"
  }, {
    path: "/jp/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___jp"
  }, {
    path: "/jp/agriculture",
    component: _22aaf262,
    name: "agriculture___jp"
  }, {
    path: "/jp/basicinfo",
    component: _45958466,
    name: "basicinfo___jp"
  }, {
    path: "/jp/blog",
    component: _681bdea7,
    name: "blog___jp"
  }, {
    path: "/jp/blogdetail",
    component: _5690a690,
    name: "blogdetail___jp"
  }, {
    path: "/jp/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___jp"
  }, {
    path: "/jp/construction",
    component: _4d194716,
    name: "construction___jp"
  }, {
    path: "/jp/consumer",
    component: _79d894fb,
    name: "consumer___jp"
  }, {
    path: "/jp/contact",
    component: _13022ede,
    name: "contact___jp"
  }, {
    path: "/jp/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___jp"
  }, {
    path: "/jp/dealer",
    component: _1a881c44,
    name: "dealer___jp"
  }, {
    path: "/jp/electric",
    component: _9d8e7d3c,
    name: "electric___jp"
  }, {
    path: "/jp/emergencypower",
    component: _385ae219,
    name: "emergencypower___jp"
  }, {
    path: "/jp/facebook",
    component: _173f67cb,
    name: "facebook___jp"
  }, {
    path: "/jp/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___jp"
  }, {
    path: "/jp/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___jp"
  }, {
    path: "/jp/geospatial",
    component: _35bb4250,
    name: "geospatial___jp"
  }, {
    path: "/jp/industry",
    component: _3e83de3a,
    name: "industry___jp"
  }, {
    path: "/jp/kol",
    component: _29285cf9,
    name: "kol___jp"
  }, {
    path: "/jp/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___jp"
  }, {
    path: "/jp/product",
    component: _dbdfcac0,
    name: "product___jp"
  }, {
    path: "/jp/productservice",
    component: _5d054c6b,
    name: "productservice___jp"
  }, {
    path: "/jp/result",
    component: _26e3323c,
    name: "result___jp"
  }, {
    path: "/jp/robots",
    component: _fe0709e4,
    name: "robots___jp"
  }, {
    path: "/jp/searchresult",
    component: _33d5650a,
    name: "searchresult___jp"
  }, {
    path: "/jp/shippingrates",
    component: _34531856,
    name: "shippingrates___jp"
  }, {
    path: "/jp/support",
    component: _154a9500,
    name: "support___jp"
  }, {
    path: "/jp/template",
    component: _369d087f,
    name: "template___jp"
  }, {
    path: "/jp/videoList",
    component: _16ef5f6a,
    name: "videoList___jp"
  }, {
    path: "/jp/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___jp"
  }, {
    path: "/pl/404",
    component: _74432aa9,
    name: "404___pl"
  }, {
    path: "/pl/about",
    component: _7ba7a13e,
    name: "about___pl"
  }, {
    path: "/pl/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___pl"
  }, {
    path: "/pl/agriculture",
    component: _22aaf262,
    name: "agriculture___pl"
  }, {
    path: "/pl/basicinfo",
    component: _45958466,
    name: "basicinfo___pl"
  }, {
    path: "/pl/blog",
    component: _681bdea7,
    name: "blog___pl"
  }, {
    path: "/pl/blogdetail",
    component: _5690a690,
    name: "blogdetail___pl"
  }, {
    path: "/pl/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___pl"
  }, {
    path: "/pl/construction",
    component: _4d194716,
    name: "construction___pl"
  }, {
    path: "/pl/consumer",
    component: _79d894fb,
    name: "consumer___pl"
  }, {
    path: "/pl/contact",
    component: _13022ede,
    name: "contact___pl"
  }, {
    path: "/pl/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___pl"
  }, {
    path: "/pl/dealer",
    component: _1a881c44,
    name: "dealer___pl"
  }, {
    path: "/pl/electric",
    component: _9d8e7d3c,
    name: "electric___pl"
  }, {
    path: "/pl/emergencypower",
    component: _385ae219,
    name: "emergencypower___pl"
  }, {
    path: "/pl/facebook",
    component: _173f67cb,
    name: "facebook___pl"
  }, {
    path: "/pl/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___pl"
  }, {
    path: "/pl/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___pl"
  }, {
    path: "/pl/geospatial",
    component: _35bb4250,
    name: "geospatial___pl"
  }, {
    path: "/pl/industry",
    component: _3e83de3a,
    name: "industry___pl"
  }, {
    path: "/pl/kol",
    component: _29285cf9,
    name: "kol___pl"
  }, {
    path: "/pl/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___pl"
  }, {
    path: "/pl/product",
    component: _dbdfcac0,
    name: "product___pl"
  }, {
    path: "/pl/productservice",
    component: _5d054c6b,
    name: "productservice___pl"
  }, {
    path: "/pl/result",
    component: _26e3323c,
    name: "result___pl"
  }, {
    path: "/pl/robots",
    component: _fe0709e4,
    name: "robots___pl"
  }, {
    path: "/pl/searchresult",
    component: _33d5650a,
    name: "searchresult___pl"
  }, {
    path: "/pl/shippingrates",
    component: _34531856,
    name: "shippingrates___pl"
  }, {
    path: "/pl/support",
    component: _154a9500,
    name: "support___pl"
  }, {
    path: "/pl/template",
    component: _369d087f,
    name: "template___pl"
  }, {
    path: "/pl/videoList",
    component: _16ef5f6a,
    name: "videoList___pl"
  }, {
    path: "/pl/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___pl"
  }, {
    path: "/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___en"
  }, {
    path: "/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___en"
  }, {
    path: "/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___en"
  }, {
    path: "/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___en"
  }, {
    path: "/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___en"
  }, {
    path: "/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___en"
  }, {
    path: "/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___en"
  }, {
    path: "/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___en"
  }, {
    path: "/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___en"
  }, {
    path: "/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___en"
  }, {
    path: "/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___en"
  }, {
    path: "/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___en"
  }, {
    path: "/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___en"
  }, {
    path: "/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___en"
  }, {
    path: "/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___en"
  }, {
    path: "/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___en"
  }, {
    path: "/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___en"
  }, {
    path: "/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___en"
  }, {
    path: "/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___en"
  }, {
    path: "/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___en"
  }, {
    path: "/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___en"
  }, {
    path: "/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___en"
  }, {
    path: "/product/powersec",
    component: _c549c45e,
    name: "product-powersec___en"
  }, {
    path: "/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___en"
  }, {
    path: "/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___en"
  }, {
    path: "/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___en"
  }, {
    path: "/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___en"
  }, {
    path: "/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___en"
  }, {
    path: "/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___en"
  }, {
    path: "/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___en"
  }, {
    path: "/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___en"
  }, {
    path: "/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___en"
  }, {
    path: "/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___en"
  }, {
    path: "/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___en"
  }, {
    path: "/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___en"
  }, {
    path: "/pt/404",
    component: _74432aa9,
    name: "404___pt"
  }, {
    path: "/pt/about",
    component: _7ba7a13e,
    name: "about___pt"
  }, {
    path: "/pt/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___pt"
  }, {
    path: "/pt/agriculture",
    component: _22aaf262,
    name: "agriculture___pt"
  }, {
    path: "/pt/basicinfo",
    component: _45958466,
    name: "basicinfo___pt"
  }, {
    path: "/pt/blog",
    component: _681bdea7,
    name: "blog___pt"
  }, {
    path: "/pt/blogdetail",
    component: _5690a690,
    name: "blogdetail___pt"
  }, {
    path: "/pt/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___pt"
  }, {
    path: "/pt/construction",
    component: _4d194716,
    name: "construction___pt"
  }, {
    path: "/pt/consumer",
    component: _79d894fb,
    name: "consumer___pt"
  }, {
    path: "/pt/contact",
    component: _13022ede,
    name: "contact___pt"
  }, {
    path: "/pt/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___pt"
  }, {
    path: "/pt/dealer",
    component: _1a881c44,
    name: "dealer___pt"
  }, {
    path: "/pt/electric",
    component: _9d8e7d3c,
    name: "electric___pt"
  }, {
    path: "/pt/emergencypower",
    component: _385ae219,
    name: "emergencypower___pt"
  }, {
    path: "/pt/facebook",
    component: _173f67cb,
    name: "facebook___pt"
  }, {
    path: "/pt/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___pt"
  }, {
    path: "/pt/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___pt"
  }, {
    path: "/pt/geospatial",
    component: _35bb4250,
    name: "geospatial___pt"
  }, {
    path: "/pt/industry",
    component: _3e83de3a,
    name: "industry___pt"
  }, {
    path: "/pt/kol",
    component: _29285cf9,
    name: "kol___pt"
  }, {
    path: "/pt/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___pt"
  }, {
    path: "/pt/product",
    component: _dbdfcac0,
    name: "product___pt"
  }, {
    path: "/pt/productservice",
    component: _5d054c6b,
    name: "productservice___pt"
  }, {
    path: "/pt/result",
    component: _26e3323c,
    name: "result___pt"
  }, {
    path: "/pt/robots",
    component: _fe0709e4,
    name: "robots___pt"
  }, {
    path: "/pt/searchresult",
    component: _33d5650a,
    name: "searchresult___pt"
  }, {
    path: "/pt/shippingrates",
    component: _34531856,
    name: "shippingrates___pt"
  }, {
    path: "/pt/support",
    component: _154a9500,
    name: "support___pt"
  }, {
    path: "/pt/template",
    component: _369d087f,
    name: "template___pt"
  }, {
    path: "/pt/videoList",
    component: _16ef5f6a,
    name: "videoList___pt"
  }, {
    path: "/pt/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___pt"
  }, {
    path: "/ru/404",
    component: _74432aa9,
    name: "404___ru"
  }, {
    path: "/ru/about",
    component: _7ba7a13e,
    name: "about___ru"
  }, {
    path: "/ru/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___ru"
  }, {
    path: "/ru/agriculture",
    component: _22aaf262,
    name: "agriculture___ru"
  }, {
    path: "/ru/basicinfo",
    component: _45958466,
    name: "basicinfo___ru"
  }, {
    path: "/ru/blog",
    component: _681bdea7,
    name: "blog___ru"
  }, {
    path: "/ru/blogdetail",
    component: _5690a690,
    name: "blogdetail___ru"
  }, {
    path: "/ru/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___ru"
  }, {
    path: "/ru/construction",
    component: _4d194716,
    name: "construction___ru"
  }, {
    path: "/ru/consumer",
    component: _79d894fb,
    name: "consumer___ru"
  }, {
    path: "/ru/contact",
    component: _13022ede,
    name: "contact___ru"
  }, {
    path: "/ru/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___ru"
  }, {
    path: "/ru/dealer",
    component: _1a881c44,
    name: "dealer___ru"
  }, {
    path: "/ru/electric",
    component: _9d8e7d3c,
    name: "electric___ru"
  }, {
    path: "/ru/emergencypower",
    component: _385ae219,
    name: "emergencypower___ru"
  }, {
    path: "/ru/facebook",
    component: _173f67cb,
    name: "facebook___ru"
  }, {
    path: "/ru/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___ru"
  }, {
    path: "/ru/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___ru"
  }, {
    path: "/ru/geospatial",
    component: _35bb4250,
    name: "geospatial___ru"
  }, {
    path: "/ru/industry",
    component: _3e83de3a,
    name: "industry___ru"
  }, {
    path: "/ru/kol",
    component: _29285cf9,
    name: "kol___ru"
  }, {
    path: "/ru/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___ru"
  }, {
    path: "/ru/product",
    component: _dbdfcac0,
    name: "product___ru"
  }, {
    path: "/ru/productservice",
    component: _5d054c6b,
    name: "productservice___ru"
  }, {
    path: "/ru/result",
    component: _26e3323c,
    name: "result___ru"
  }, {
    path: "/ru/robots",
    component: _fe0709e4,
    name: "robots___ru"
  }, {
    path: "/ru/searchresult",
    component: _33d5650a,
    name: "searchresult___ru"
  }, {
    path: "/ru/shippingrates",
    component: _34531856,
    name: "shippingrates___ru"
  }, {
    path: "/ru/support",
    component: _154a9500,
    name: "support___ru"
  }, {
    path: "/ru/template",
    component: _369d087f,
    name: "template___ru"
  }, {
    path: "/ru/videoList",
    component: _16ef5f6a,
    name: "videoList___ru"
  }, {
    path: "/ru/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___ru"
  }, {
    path: "/sv/404",
    component: _74432aa9,
    name: "404___sv"
  }, {
    path: "/sv/about",
    component: _7ba7a13e,
    name: "about___sv"
  }, {
    path: "/sv/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___sv"
  }, {
    path: "/sv/agriculture",
    component: _22aaf262,
    name: "agriculture___sv"
  }, {
    path: "/sv/basicinfo",
    component: _45958466,
    name: "basicinfo___sv"
  }, {
    path: "/sv/blog",
    component: _681bdea7,
    name: "blog___sv"
  }, {
    path: "/sv/blogdetail",
    component: _5690a690,
    name: "blogdetail___sv"
  }, {
    path: "/sv/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___sv"
  }, {
    path: "/sv/construction",
    component: _4d194716,
    name: "construction___sv"
  }, {
    path: "/sv/consumer",
    component: _79d894fb,
    name: "consumer___sv"
  }, {
    path: "/sv/contact",
    component: _13022ede,
    name: "contact___sv"
  }, {
    path: "/sv/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___sv"
  }, {
    path: "/sv/dealer",
    component: _1a881c44,
    name: "dealer___sv"
  }, {
    path: "/sv/electric",
    component: _9d8e7d3c,
    name: "electric___sv"
  }, {
    path: "/sv/emergencypower",
    component: _385ae219,
    name: "emergencypower___sv"
  }, {
    path: "/sv/facebook",
    component: _173f67cb,
    name: "facebook___sv"
  }, {
    path: "/sv/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___sv"
  }, {
    path: "/sv/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___sv"
  }, {
    path: "/sv/geospatial",
    component: _35bb4250,
    name: "geospatial___sv"
  }, {
    path: "/sv/industry",
    component: _3e83de3a,
    name: "industry___sv"
  }, {
    path: "/sv/kol",
    component: _29285cf9,
    name: "kol___sv"
  }, {
    path: "/sv/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___sv"
  }, {
    path: "/sv/product",
    component: _dbdfcac0,
    name: "product___sv"
  }, {
    path: "/sv/productservice",
    component: _5d054c6b,
    name: "productservice___sv"
  }, {
    path: "/sv/result",
    component: _26e3323c,
    name: "result___sv"
  }, {
    path: "/sv/robots",
    component: _fe0709e4,
    name: "robots___sv"
  }, {
    path: "/sv/searchresult",
    component: _33d5650a,
    name: "searchresult___sv"
  }, {
    path: "/sv/shippingrates",
    component: _34531856,
    name: "shippingrates___sv"
  }, {
    path: "/sv/support",
    component: _154a9500,
    name: "support___sv"
  }, {
    path: "/sv/template",
    component: _369d087f,
    name: "template___sv"
  }, {
    path: "/sv/videoList",
    component: _16ef5f6a,
    name: "videoList___sv"
  }, {
    path: "/sv/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___sv"
  }, {
    path: "/tr/404",
    component: _74432aa9,
    name: "404___tr"
  }, {
    path: "/tr/about",
    component: _7ba7a13e,
    name: "about___tr"
  }, {
    path: "/tr/aftersalespolicy",
    component: _57d70432,
    name: "aftersalespolicy___tr"
  }, {
    path: "/tr/agriculture",
    component: _22aaf262,
    name: "agriculture___tr"
  }, {
    path: "/tr/basicinfo",
    component: _45958466,
    name: "basicinfo___tr"
  }, {
    path: "/tr/blog",
    component: _681bdea7,
    name: "blog___tr"
  }, {
    path: "/tr/blogdetail",
    component: _5690a690,
    name: "blogdetail___tr"
  }, {
    path: "/tr/brand-upgraded",
    component: _5742165a,
    name: "brand-upgraded___tr"
  }, {
    path: "/tr/construction",
    component: _4d194716,
    name: "construction___tr"
  }, {
    path: "/tr/consumer",
    component: _79d894fb,
    name: "consumer___tr"
  }, {
    path: "/tr/contact",
    component: _13022ede,
    name: "contact___tr"
  }, {
    path: "/tr/cookiepolicy",
    component: _0584589b,
    name: "cookiepolicy___tr"
  }, {
    path: "/tr/dealer",
    component: _1a881c44,
    name: "dealer___tr"
  }, {
    path: "/tr/electric",
    component: _9d8e7d3c,
    name: "electric___tr"
  }, {
    path: "/tr/emergencypower",
    component: _385ae219,
    name: "emergencypower___tr"
  }, {
    path: "/tr/facebook",
    component: _173f67cb,
    name: "facebook___tr"
  }, {
    path: "/tr/fjd-farmbook-farm-management-software",
    component: _7948a38c,
    name: "fjd-farmbook-farm-management-software___tr"
  }, {
    path: "/tr/FJD-witness",
    component: _0c7fc2dd,
    name: "FJD-witness___tr"
  }, {
    path: "/tr/geospatial",
    component: _35bb4250,
    name: "geospatial___tr"
  }, {
    path: "/tr/industry",
    component: _3e83de3a,
    name: "industry___tr"
  }, {
    path: "/tr/kol",
    component: _29285cf9,
    name: "kol___tr"
  }, {
    path: "/tr/privacypolicy",
    component: _d1d413aa,
    name: "privacypolicy___tr"
  }, {
    path: "/tr/product",
    component: _dbdfcac0,
    name: "product___tr"
  }, {
    path: "/tr/productservice",
    component: _5d054c6b,
    name: "productservice___tr"
  }, {
    path: "/tr/result",
    component: _26e3323c,
    name: "result___tr"
  }, {
    path: "/tr/robots",
    component: _fe0709e4,
    name: "robots___tr"
  }, {
    path: "/tr/searchresult",
    component: _33d5650a,
    name: "searchresult___tr"
  }, {
    path: "/tr/shippingrates",
    component: _34531856,
    name: "shippingrates___tr"
  }, {
    path: "/tr/support",
    component: _154a9500,
    name: "support___tr"
  }, {
    path: "/tr/template",
    component: _369d087f,
    name: "template___tr"
  }, {
    path: "/tr/videoList",
    component: _16ef5f6a,
    name: "videoList___tr"
  }, {
    path: "/tr/webinarcenter",
    component: _6ba30b70,
    name: "webinarcenter___tr"
  }, {
    path: "/de/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___de"
  }, {
    path: "/de/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___de"
  }, {
    path: "/de/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___de"
  }, {
    path: "/de/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___de"
  }, {
    path: "/de/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___de"
  }, {
    path: "/de/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___de"
  }, {
    path: "/de/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___de"
  }, {
    path: "/de/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___de"
  }, {
    path: "/de/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___de"
  }, {
    path: "/de/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___de"
  }, {
    path: "/de/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___de"
  }, {
    path: "/de/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___de"
  }, {
    path: "/de/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___de"
  }, {
    path: "/de/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___de"
  }, {
    path: "/de/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___de"
  }, {
    path: "/de/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___de"
  }, {
    path: "/de/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___de"
  }, {
    path: "/de/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___de"
  }, {
    path: "/de/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___de"
  }, {
    path: "/de/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___de"
  }, {
    path: "/de/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___de"
  }, {
    path: "/de/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___de"
  }, {
    path: "/de/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___de"
  }, {
    path: "/de/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___de"
  }, {
    path: "/de/product/powersec",
    component: _c549c45e,
    name: "product-powersec___de"
  }, {
    path: "/de/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___de"
  }, {
    path: "/de/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___de"
  }, {
    path: "/de/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___de"
  }, {
    path: "/de/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___de"
  }, {
    path: "/de/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___de"
  }, {
    path: "/de/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___de"
  }, {
    path: "/de/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___de"
  }, {
    path: "/de/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___de"
  }, {
    path: "/de/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___de"
  }, {
    path: "/de/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___de"
  }, {
    path: "/de/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___de"
  }, {
    path: "/de/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___de"
  }, {
    path: "/es/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___es"
  }, {
    path: "/es/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___es"
  }, {
    path: "/es/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___es"
  }, {
    path: "/es/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___es"
  }, {
    path: "/es/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___es"
  }, {
    path: "/es/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___es"
  }, {
    path: "/es/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___es"
  }, {
    path: "/es/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___es"
  }, {
    path: "/es/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___es"
  }, {
    path: "/es/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___es"
  }, {
    path: "/es/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___es"
  }, {
    path: "/es/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___es"
  }, {
    path: "/es/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___es"
  }, {
    path: "/es/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___es"
  }, {
    path: "/es/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___es"
  }, {
    path: "/es/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___es"
  }, {
    path: "/es/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___es"
  }, {
    path: "/es/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___es"
  }, {
    path: "/es/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___es"
  }, {
    path: "/es/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___es"
  }, {
    path: "/es/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___es"
  }, {
    path: "/es/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___es"
  }, {
    path: "/es/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___es"
  }, {
    path: "/es/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___es"
  }, {
    path: "/es/product/powersec",
    component: _c549c45e,
    name: "product-powersec___es"
  }, {
    path: "/es/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___es"
  }, {
    path: "/es/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___es"
  }, {
    path: "/es/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___es"
  }, {
    path: "/es/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___es"
  }, {
    path: "/es/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___es"
  }, {
    path: "/es/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___es"
  }, {
    path: "/es/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___es"
  }, {
    path: "/es/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___es"
  }, {
    path: "/es/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___es"
  }, {
    path: "/es/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___es"
  }, {
    path: "/es/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___es"
  }, {
    path: "/es/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___es"
  }, {
    path: "/fr/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___fr"
  }, {
    path: "/fr/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___fr"
  }, {
    path: "/fr/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___fr"
  }, {
    path: "/fr/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___fr"
  }, {
    path: "/fr/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___fr"
  }, {
    path: "/fr/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___fr"
  }, {
    path: "/fr/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___fr"
  }, {
    path: "/fr/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___fr"
  }, {
    path: "/fr/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___fr"
  }, {
    path: "/fr/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___fr"
  }, {
    path: "/fr/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___fr"
  }, {
    path: "/fr/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___fr"
  }, {
    path: "/fr/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___fr"
  }, {
    path: "/fr/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___fr"
  }, {
    path: "/fr/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___fr"
  }, {
    path: "/fr/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___fr"
  }, {
    path: "/fr/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___fr"
  }, {
    path: "/fr/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___fr"
  }, {
    path: "/fr/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___fr"
  }, {
    path: "/fr/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___fr"
  }, {
    path: "/fr/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___fr"
  }, {
    path: "/fr/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___fr"
  }, {
    path: "/fr/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___fr"
  }, {
    path: "/fr/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___fr"
  }, {
    path: "/fr/product/powersec",
    component: _c549c45e,
    name: "product-powersec___fr"
  }, {
    path: "/fr/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___fr"
  }, {
    path: "/fr/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___fr"
  }, {
    path: "/fr/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___fr"
  }, {
    path: "/fr/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___fr"
  }, {
    path: "/fr/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___fr"
  }, {
    path: "/fr/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___fr"
  }, {
    path: "/fr/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___fr"
  }, {
    path: "/fr/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___fr"
  }, {
    path: "/fr/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___fr"
  }, {
    path: "/fr/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___fr"
  }, {
    path: "/fr/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___fr"
  }, {
    path: "/fr/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___fr"
  }, {
    path: "/jp/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___jp"
  }, {
    path: "/jp/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___jp"
  }, {
    path: "/jp/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___jp"
  }, {
    path: "/jp/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___jp"
  }, {
    path: "/jp/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___jp"
  }, {
    path: "/jp/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___jp"
  }, {
    path: "/jp/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___jp"
  }, {
    path: "/jp/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___jp"
  }, {
    path: "/jp/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___jp"
  }, {
    path: "/jp/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___jp"
  }, {
    path: "/jp/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___jp"
  }, {
    path: "/jp/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___jp"
  }, {
    path: "/jp/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___jp"
  }, {
    path: "/jp/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___jp"
  }, {
    path: "/jp/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___jp"
  }, {
    path: "/jp/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___jp"
  }, {
    path: "/jp/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___jp"
  }, {
    path: "/jp/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___jp"
  }, {
    path: "/jp/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___jp"
  }, {
    path: "/jp/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___jp"
  }, {
    path: "/jp/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___jp"
  }, {
    path: "/jp/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___jp"
  }, {
    path: "/jp/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___jp"
  }, {
    path: "/jp/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___jp"
  }, {
    path: "/jp/product/powersec",
    component: _c549c45e,
    name: "product-powersec___jp"
  }, {
    path: "/jp/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___jp"
  }, {
    path: "/jp/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___jp"
  }, {
    path: "/jp/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___jp"
  }, {
    path: "/jp/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___jp"
  }, {
    path: "/jp/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___jp"
  }, {
    path: "/jp/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___jp"
  }, {
    path: "/jp/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___jp"
  }, {
    path: "/jp/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___jp"
  }, {
    path: "/jp/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___jp"
  }, {
    path: "/jp/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___jp"
  }, {
    path: "/jp/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___jp"
  }, {
    path: "/jp/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___jp"
  }, {
    path: "/pl/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___pl"
  }, {
    path: "/pl/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___pl"
  }, {
    path: "/pl/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___pl"
  }, {
    path: "/pl/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___pl"
  }, {
    path: "/pl/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___pl"
  }, {
    path: "/pl/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___pl"
  }, {
    path: "/pl/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___pl"
  }, {
    path: "/pl/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___pl"
  }, {
    path: "/pl/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___pl"
  }, {
    path: "/pl/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___pl"
  }, {
    path: "/pl/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___pl"
  }, {
    path: "/pl/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___pl"
  }, {
    path: "/pl/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___pl"
  }, {
    path: "/pl/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___pl"
  }, {
    path: "/pl/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___pl"
  }, {
    path: "/pl/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___pl"
  }, {
    path: "/pl/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___pl"
  }, {
    path: "/pl/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___pl"
  }, {
    path: "/pl/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___pl"
  }, {
    path: "/pl/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___pl"
  }, {
    path: "/pl/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___pl"
  }, {
    path: "/pl/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___pl"
  }, {
    path: "/pl/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___pl"
  }, {
    path: "/pl/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___pl"
  }, {
    path: "/pl/product/powersec",
    component: _c549c45e,
    name: "product-powersec___pl"
  }, {
    path: "/pl/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___pl"
  }, {
    path: "/pl/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___pl"
  }, {
    path: "/pl/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___pl"
  }, {
    path: "/pl/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___pl"
  }, {
    path: "/pl/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___pl"
  }, {
    path: "/pl/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___pl"
  }, {
    path: "/pl/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___pl"
  }, {
    path: "/pl/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___pl"
  }, {
    path: "/pl/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___pl"
  }, {
    path: "/pl/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___pl"
  }, {
    path: "/pl/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___pl"
  }, {
    path: "/pl/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___pl"
  }, {
    path: "/pt/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___pt"
  }, {
    path: "/pt/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___pt"
  }, {
    path: "/pt/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___pt"
  }, {
    path: "/pt/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___pt"
  }, {
    path: "/pt/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___pt"
  }, {
    path: "/pt/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___pt"
  }, {
    path: "/pt/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___pt"
  }, {
    path: "/pt/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___pt"
  }, {
    path: "/pt/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___pt"
  }, {
    path: "/pt/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___pt"
  }, {
    path: "/pt/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___pt"
  }, {
    path: "/pt/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___pt"
  }, {
    path: "/pt/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___pt"
  }, {
    path: "/pt/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___pt"
  }, {
    path: "/pt/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___pt"
  }, {
    path: "/pt/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___pt"
  }, {
    path: "/pt/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___pt"
  }, {
    path: "/pt/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___pt"
  }, {
    path: "/pt/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___pt"
  }, {
    path: "/pt/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___pt"
  }, {
    path: "/pt/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___pt"
  }, {
    path: "/pt/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___pt"
  }, {
    path: "/pt/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___pt"
  }, {
    path: "/pt/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___pt"
  }, {
    path: "/pt/product/powersec",
    component: _c549c45e,
    name: "product-powersec___pt"
  }, {
    path: "/pt/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___pt"
  }, {
    path: "/pt/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___pt"
  }, {
    path: "/pt/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___pt"
  }, {
    path: "/pt/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___pt"
  }, {
    path: "/pt/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___pt"
  }, {
    path: "/pt/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___pt"
  }, {
    path: "/pt/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___pt"
  }, {
    path: "/pt/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___pt"
  }, {
    path: "/pt/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___pt"
  }, {
    path: "/pt/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___pt"
  }, {
    path: "/pt/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___pt"
  }, {
    path: "/pt/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___pt"
  }, {
    path: "/ru/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___ru"
  }, {
    path: "/ru/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___ru"
  }, {
    path: "/ru/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___ru"
  }, {
    path: "/ru/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___ru"
  }, {
    path: "/ru/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___ru"
  }, {
    path: "/ru/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___ru"
  }, {
    path: "/ru/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___ru"
  }, {
    path: "/ru/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___ru"
  }, {
    path: "/ru/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___ru"
  }, {
    path: "/ru/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___ru"
  }, {
    path: "/ru/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___ru"
  }, {
    path: "/ru/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___ru"
  }, {
    path: "/ru/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___ru"
  }, {
    path: "/ru/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___ru"
  }, {
    path: "/ru/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___ru"
  }, {
    path: "/ru/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___ru"
  }, {
    path: "/ru/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___ru"
  }, {
    path: "/ru/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___ru"
  }, {
    path: "/ru/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___ru"
  }, {
    path: "/ru/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___ru"
  }, {
    path: "/ru/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___ru"
  }, {
    path: "/ru/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___ru"
  }, {
    path: "/ru/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___ru"
  }, {
    path: "/ru/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___ru"
  }, {
    path: "/ru/product/powersec",
    component: _c549c45e,
    name: "product-powersec___ru"
  }, {
    path: "/ru/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___ru"
  }, {
    path: "/ru/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___ru"
  }, {
    path: "/ru/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___ru"
  }, {
    path: "/ru/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___ru"
  }, {
    path: "/ru/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___ru"
  }, {
    path: "/ru/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___ru"
  }, {
    path: "/ru/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___ru"
  }, {
    path: "/ru/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___ru"
  }, {
    path: "/ru/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___ru"
  }, {
    path: "/ru/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___ru"
  }, {
    path: "/ru/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___ru"
  }, {
    path: "/ru/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___ru"
  }, {
    path: "/sv/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___sv"
  }, {
    path: "/sv/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___sv"
  }, {
    path: "/sv/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___sv"
  }, {
    path: "/sv/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___sv"
  }, {
    path: "/sv/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___sv"
  }, {
    path: "/sv/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___sv"
  }, {
    path: "/sv/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___sv"
  }, {
    path: "/sv/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___sv"
  }, {
    path: "/sv/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___sv"
  }, {
    path: "/sv/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___sv"
  }, {
    path: "/sv/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___sv"
  }, {
    path: "/sv/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___sv"
  }, {
    path: "/sv/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___sv"
  }, {
    path: "/sv/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___sv"
  }, {
    path: "/sv/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___sv"
  }, {
    path: "/sv/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___sv"
  }, {
    path: "/sv/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___sv"
  }, {
    path: "/sv/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___sv"
  }, {
    path: "/sv/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___sv"
  }, {
    path: "/sv/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___sv"
  }, {
    path: "/sv/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___sv"
  }, {
    path: "/sv/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___sv"
  }, {
    path: "/sv/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___sv"
  }, {
    path: "/sv/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___sv"
  }, {
    path: "/sv/product/powersec",
    component: _c549c45e,
    name: "product-powersec___sv"
  }, {
    path: "/sv/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___sv"
  }, {
    path: "/sv/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___sv"
  }, {
    path: "/sv/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___sv"
  }, {
    path: "/sv/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___sv"
  }, {
    path: "/sv/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___sv"
  }, {
    path: "/sv/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___sv"
  }, {
    path: "/sv/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___sv"
  }, {
    path: "/sv/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___sv"
  }, {
    path: "/sv/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___sv"
  }, {
    path: "/sv/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___sv"
  }, {
    path: "/sv/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___sv"
  }, {
    path: "/sv/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___sv"
  }, {
    path: "/tr/ads/autosteering-kit",
    component: _4f7bd5ad,
    name: "ads-autosteering-kit___tr"
  }, {
    path: "/tr/ads/excavator-guidance-b",
    component: _82636bba,
    name: "ads-excavator-guidance-b___tr"
  }, {
    path: "/tr/product/aerial-mapper",
    component: _41cc51f9,
    name: "product-aerial-mapper___tr"
  }, {
    path: "/tr/product/aerial-mapper-specs",
    component: _d9cc1478,
    name: "product-aerial-mapper-specs___tr"
  }, {
    path: "/tr/product/al01-3d-land-leveling-system",
    component: _7a84c15c,
    name: "product-al01-3d-land-leveling-system___tr"
  }, {
    path: "/tr/product/al01-3d-land-leveling-system-specs",
    component: _aae7e232,
    name: "product-al01-3d-land-leveling-system-specs___tr"
  }, {
    path: "/tr/product/autosteeringkit",
    component: _060c28f2,
    name: "product-autosteeringkit___tr"
  }, {
    path: "/tr/product/autosteeringspecs",
    component: _990f966e,
    name: "product-autosteeringspecs___tr"
  }, {
    path: "/tr/product/basestation",
    component: _4cf2b858,
    name: "product-basestation___tr"
  }, {
    path: "/tr/product/dieselgenerator",
    component: _3a512f6c,
    name: "product-dieselgenerator___tr"
  }, {
    path: "/tr/product/dieselgeneratorspec",
    component: _147dfa76,
    name: "product-dieselgeneratorspec___tr"
  }, {
    path: "/tr/product/dieselgensent",
    component: _78c1851f,
    name: "product-dieselgensent___tr"
  }, {
    path: "/tr/product/dieselgensentspec",
    component: _1cf6ad1a,
    name: "product-dieselgensentspec___tr"
  }, {
    path: "/tr/product/disinfectionRobot",
    component: _04fa91f6,
    name: "product-disinfectionRobot___tr"
  }, {
    path: "/tr/product/excavatorguidance",
    component: _305aa8f8,
    name: "product-excavatorguidance___tr"
  }, {
    path: "/tr/product/excavatorSpecs",
    component: _4fa008bc,
    name: "product-excavatorSpecs___tr"
  }, {
    path: "/tr/product/fjd-connect",
    component: _5d2c9e4e,
    name: "product-fjd-connect___tr"
  }, {
    path: "/tr/product/fjd-easy-dig-2d-excav-specs",
    component: _7ebbe62f,
    name: "product-fjd-easy-dig-2d-excav-specs___tr"
  }, {
    path: "/tr/product/fjd-easy-dig-g21-2d-excav",
    component: _50e9676b,
    name: "product-fjd-easy-dig-g21-2d-excav___tr"
  }, {
    path: "/tr/product/lawnmower",
    component: _08ab8f47,
    name: "product-lawnmower___tr"
  }, {
    path: "/tr/product/lawnmowerspec",
    component: _36ff6342,
    name: "product-lawnmowerspec___tr"
  }, {
    path: "/tr/product/orchardPlantProtection",
    component: _4871073e,
    name: "product-orchardPlantProtection___tr"
  }, {
    path: "/tr/product/orchardPlantProtectionSpecs",
    component: _033aded0,
    name: "product-orchardPlantProtectionSpecs___tr"
  }, {
    path: "/tr/product/piledriver",
    component: _7fae347f,
    name: "product-piledriver___tr"
  }, {
    path: "/tr/product/powersec",
    component: _c549c45e,
    name: "product-powersec___tr"
  }, {
    path: "/tr/product/powersecspec",
    component: _965ec668,
    name: "product-powersecspec___tr"
  }, {
    path: "/tr/product/refractometer",
    component: _31894cbe,
    name: "product-refractometer___tr"
  }, {
    path: "/tr/product/refractometerspec",
    component: _17438d39,
    name: "product-refractometerspec___tr"
  }, {
    path: "/tr/product/ricetransplanter",
    component: _0989e324,
    name: "product-ricetransplanter___tr"
  }, {
    path: "/tr/product/ricetransplanterspec",
    component: _49dcf6e9,
    name: "product-ricetransplanterspec___tr"
  }, {
    path: "/tr/product/tractor",
    component: _90d3aa70,
    name: "product-tractor___tr"
  }, {
    path: "/tr/product/tractorspecs",
    component: _23bda9a6,
    name: "product-tractorspecs___tr"
  }, {
    path: "/tr/product/trion-s1-3d-lidar-scanner",
    component: _2cd812ca,
    name: "product-trion-s1-3d-lidar-scanner___tr"
  }, {
    path: "/tr/product/trion-s1-3d-lidar-scanner-specs",
    component: _b367d456,
    name: "product-trion-s1-3d-lidar-scanner-specs___tr"
  }, {
    path: "/tr/product/trion-v1-series-rtk-rover",
    component: _01e504a8,
    name: "product-trion-v1-series-rtk-rover___tr"
  }, {
    path: "/tr/product/trion-v1-series-rtk-rover-specs",
    component: _448a4f37,
    name: "product-trion-v1-series-rtk-rover-specs___tr"
  }, {
    path: "/tr/product/wificamera",
    component: _5666e1c2,
    name: "product-wificamera___tr"
  }, {
    path: "/de/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___de"
  }, {
    path: "/es/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___es"
  }, {
    path: "/fr/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___fr"
  }, {
    path: "/jp/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___jp"
  }, {
    path: "/pl/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___pl"
  }, {
    path: "/pt/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___pt"
  }, {
    path: "/ru/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___ru"
  }, {
    path: "/sv/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___sv"
  }, {
    path: "/tr/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___tr"
  }, {
    path: "/activity/webinardetail/:id?",
    component: _8a55d230,
    name: "activity-webinardetail-id___en"
  }, {
    path: "/de/blog/:id",
    component: _c2e14262,
    name: "blog-id___de"
  }, {
    path: "/es/blog/:id",
    component: _c2e14262,
    name: "blog-id___es"
  }, {
    path: "/fr/blog/:id",
    component: _c2e14262,
    name: "blog-id___fr"
  }, {
    path: "/jp/blog/:id",
    component: _c2e14262,
    name: "blog-id___jp"
  }, {
    path: "/pl/blog/:id",
    component: _c2e14262,
    name: "blog-id___pl"
  }, {
    path: "/pt/blog/:id",
    component: _c2e14262,
    name: "blog-id___pt"
  }, {
    path: "/ru/blog/:id",
    component: _c2e14262,
    name: "blog-id___ru"
  }, {
    path: "/sv/blog/:id",
    component: _c2e14262,
    name: "blog-id___sv"
  }, {
    path: "/tr/blog/:id",
    component: _c2e14262,
    name: "blog-id___tr"
  }, {
    path: "/blog/:id",
    component: _c2e14262,
    name: "blog-id___en"
  }, {
    path: "/",
    component: _65c05dc0,
    children: [{
      path: "",
      component: _79bf9443,
      name: "index___en"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
